import { Power0, Power3, Expo } from 'gsap'
import SplitText from '../lib/SplitText'
import AnimatedComponent from './AnimatedComponent'

class SidebarContent extends AnimatedComponent {
  buildTimelineIn () {
    const $el = this.$el
    const splitText = new SplitText($el.find('.sidebar-content__content').find('h2, p, li'), { type: 'lines' })

    this.timelineIn
      .fromTo(
        $el.find('.sidebar-content__image'),
        1.2,
        { x: '-100%' },
        { x: '0%', ease: Expo.easeInOut },
        0
      )
      .fromTo(
        $el.find('.sidebar-content__image').find('.bg'),
        1.2,
        { x: '100%' },
        { x: '0%', ease: Expo.easeInOut },
        0
      )
      .fromTo(
        $el.find('.sidebar-content__content'),
        0.8,
        { x: '100%' },
        { x: '0%', ease: Power3.easeOut },
        1.2
      )
      .staggerFromTo(
        splitText.lines,
        1.2,
        { opacity: 0 },
        { opacity: 1, ease: Power0.easeNone },
        0.075,
        1.2
      )
  }
}

export default SidebarContent



// WEBPACK FOOTER //
// ./scripts/components/SidebarContent.js